import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgotPassword/forgot-password.component';
import { UserVerificationComponent } from './verify/user-verification.component';
import { RegistrationComponent } from './registration/registration.component';
import { CongratulationsComponent } from './congratulations/congratulations.component';
import { AuthGuard } from '../shared/guards/auth.guard';

const routes: Routes = [
	{
		path: 'auth',
		children: [
			{
				path: 'login',
				component: LoginComponent
			},
			{
				path: 'register',
				component: RegistrationComponent
			},
			{
				path: 'verify',
				component: UserVerificationComponent
			},
			{
				path: 'resetpassword',
				component: ResetPasswordComponent
			},
			{
				path: 'forgotpassword',
				component: ForgotPasswordComponent
			},
			{
				path: 'congratulations',
				component: CongratulationsComponent
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class AuthRoutingModule {}
